import {AfterViewInit, Component} from '@angular/core';
import {AppService} from '../../services/app.service';

declare const $;

@Component({
  selector: 'pm-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements AfterViewInit {

  constructor(
    private app: AppService
  ) {
    app.setTitle('FAQ');
  }

  ngAfterViewInit(): void {
    $(document).ready(() => {
      $('.accordion').accordion({defaultOpen: 'section1'}); // some_id section1 in demo
    });
    if ($('.accordion').hasClass('accordion-open')) {
      $(this).parents('.accordian-body').addClass('active');
    }
  }

}
